<script setup lang="ts">
definePageMeta({ path: '/exhibitions-events' })

const route = useRoute()
const { locale } = useI18n()

const runtimeConfig = useRuntimeConfig()

const previewSecret = runtimeConfig?.previewSecret || runtimeConfig?.public?.previewSecret
const isPreview = computed(() => route?.query?.previewSecret === previewSecret)

const { data: pageData, error: pageError } = await useAsyncData<ProgrammePage>(
  () => `programme-page-${locale.value}`,
  () => $fetch<ProgrammePage>('/api/payload-gql', {
    method: 'POST',
    body: {
      query: GlobalProgrammePageQuery,
      variables: {
        locale: locale.value,
        isPreview: isPreview.value,
      },
      isPreview: isPreview.value,
    },
  })
)

if (pageError.value) {
  throw createError({ statusCode: 500, statusMessage: 'Error fetching page' })
}

usePageSeo({
  title: () => pageData.value?.title || 'Programme',
})
</script>

<template>
  <page-layout>
    <template #header>
      <page-header
        :title="pageData?.title || 'Programme'"
        :route="{
          name: 'programme',
          title: pageData?.title,
          slug: pageData?.slug,
        }"
        :include-breadcrumbs="true"
      />
    </template>

    <template #default>
      <pages-programme
        v-if="pageData"
        :data="pageData"
      />
    </template>
  </page-layout>
</template>
